import React, { ComponentType, useState } from 'react';
import { Box } from '@mui/material';
import Button from 'components/Button/Button';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import SettingsSidebar, { Tab } from './components/SettingsSidebar/SettingsSidebar';
import { useNavigate } from 'react-router-dom';
import MyAccountSettings, { MyAccountSettingsProps } from './components/MyAccountSettings/MyAccountSettings';
import UserManagementSettings, {
  UserManagementSettingsProps,
} from './components/UserManagementSettings/UserManagementSetting';
import styles from './SettingsPage.module.css';

type ComponentProps = MyAccountSettingsProps | UserManagementSettingsProps;

const components: { [key: string]: ComponentType<ComponentProps> } = {
  MyAccountSettings,
  UserManagementSettings,
};

const settingsTabs = [
  {
    label: 'My account',
    iconName: 'MyAccountIcon',
    component: 'MyAccountSettings',
  },
  {
    label: 'User management ',
    iconName: 'UserManagementIcon',
    component: 'UserManagementSettings',
  },
];

export const SettingsPage = () => {
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState<Tab>(settingsTabs[0]);

  const handleGoBack = () => {
    navigate('/documents');
  };

  const handleChangeTab = (tab: Tab) => {
    setCurrentTab(tab);
  };

  const componentName: keyof typeof components = currentTab.component;

  const ComponentToRender = components[componentName];

  return (
    <Box className={styles.mainPage}>
      <Box className={styles.controlsSection}>
        <Button variant='tertiary' startIcon={<ArrowBackRoundedIcon />} onClick={handleGoBack}>
          Back
        </Button>
      </Box>
      <Box className={styles.settingsContainer}>
        <Box>
          <SettingsSidebar tabs={settingsTabs} onChangeTab={handleChangeTab} />
        </Box>
        <Box className={styles.settingsMainBody}>
          <ComponentToRender text={currentTab.label} />
        </Box>
      </Box>
    </Box>
  );
};
